// extracted by mini-css-extract-plugin
module.exports = {"cover":"import_cover__37T2L","fileTip":"import_fileTip__7uJm_"};